import { cn } from '@ahm/common-helpers';
import {
  Box,
  type BoxProps,
  Container,
  Text,
  Title,
  type ContainerProps,
} from '@mantine/core';
import type { ReactNode, SVGProps } from 'react';

interface ResultBlockProps extends Omit<ContainerProps, 'title'> {
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  iconSize?: number;
  iconProps?: BoxProps;
  title?: string | ReactNode;
  description?: string | ReactNode;
  requestId?: string;
  children?: ReactNode;
  innerClassName?: string;
}

export function ResultBlock({
  icon: Icon,
  iconSize = 120,
  iconProps,
  title,
  description,
  requestId,
  children,
  className,
  innerClassName,
  ...props
}: ResultBlockProps) {
  return (
    <Container {...props}>
      <div
        className={cn(
          'mx-auto flex min-h-[50dvh] max-w-[400px] flex-col items-center justify-center space-y-2 py-12 text-center',
          className
        )}
      >
        {Icon ? (
          <Box
            pos="relative"
            mx="auto"
            mb={8}
            h={iconSize}
            w="100%"
            {...iconProps}
          >
            <Icon height="100%" width="100%" />
          </Box>
        ) : null}
        {/* {iconUrl ? (
          <Box pos="relative" mx="auto" mb={8} h={120} w="100%">
            <Image
              alt="404"
              fill
              style={{ objectFit: 'contain' }}
              src={iconUrl}
              priority
            />
          </Box>
        ) : null} */}
        <Title order={2} size="h5" fw={600} ta="center">
          {title}
        </Title>
        {description ? (
          <Text size="sm" ta="center" c="neutral" fw={500}>
            {description}
          </Text>
        ) : null}
        {requestId ? (
          <Text size="sm" ta="center" c="neutral" fw={600}>
            Request ID:{' '}
            <code className="font-mono font-normal">{requestId}</code>
          </Text>
        ) : null}
        {children}
      </div>
    </Container>
  );
}
